import { ListItemIcon, ListItemText } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import type { BillingInterval } from '@vy/types';
import React from 'react';
import { useDialog } from '../../../../../hooks/use-dialog';
import { UpdateContractDialog } from './UpdateContractDialog';
import { PenThin } from '@vy/ui-design-system';

type MenuItemUpdateContractProps = {
  contractId: string;
  contractStartDate: Date;
  isEditable: boolean;
  billingInterval: BillingInterval;
  disabled?: boolean;
};

export const MenuItemUpdateContract: React.FC<MenuItemUpdateContractProps> = ({
  contractId,
  contractStartDate: _contractStartDate,
  billingInterval: _billingInterval,
  isEditable,
  disabled,
}) => {
  const { isDialogOpen, handleOpen, handleClose } = useDialog();

  return (
    <>
      <MenuItem disabled={disabled} onClick={handleOpen}>
        <ListItemIcon>
          <PenThin />
        </ListItemIcon>
        <ListItemText>Edit</ListItemText>
      </MenuItem>

      <UpdateContractDialog
        isDialogOpen={isDialogOpen}
        contractId={contractId}
        handleClose={handleClose}
        isEditable={isEditable}
      />
    </>
  );
};
